
export default {
	name: 'StakingSection',
	data () {
		return {
			baseURL: process.env.NUXT_APP_PANEL_BASE_URL,
			fetchingPlans: true,
			stakingPlans: [],
		};
	},
	methods: {
		formatNumber (num, fix, sign)
		{
			if(typeof fix != 'number' || fix < 0) fix = -1;
			const signed = Math.sign(num);
			num = Math.abs(num);
			const parts = String(num).split('.');
			const decimal = Number(parts[0]).toLocaleString('en');
			const fraction = (parts.length == 2 && fix != 0 ? (fix > 0 ? Number('0.' + parts[1]).toFixed(fix).substring(1) : '.' + parts[1]) : '');
			return (signed > 0 ? (sign ? '+' : '') : signed < 0 ? '−' : '') + decimal + fraction;
		},
		async fetchStakingPlans ()
		{
			this.fetchingPlans = true;
			const response = await this.$store.dispatch('markets/fetchStakingPlans');
			this.fetchingPlans = false;
			if(response && response.code == 0){
				this.stakingPlans = response.data.content.map((plan) => {
					if(plan.durations.length == 0 || plan.details.length == 0) return null;
					const biggestDuration = plan.durations.reduce((acc, cur) => (!acc || cur.duration > acc.duration ? cur : acc));
					const durationDetail = plan.details.find((det) => (det.id === biggestDuration.planDetailId));
					if(!durationDetail) return null;
					return {
						popular: true,
						id: plan.stakingPlanId,
						description: plan.description,
						unit: plan.coinDto.coinUnit,
						displayName: plan.coinDto.displayName,
						scale: plan.coinDto.stakeScale,
						duration: biggestDuration,
						apy: Number(durationDetail.activeAPY),
						minimum: Number(durationDetail.minStakePerUser),
					};
				}).filter((plan) => !!plan);
			}
		},
	},
	created ()
	{
		this.fetchStakingPlans();
	},
}
